import React from 'react'
import './GetToKnow.css'
import { useNavigate } from 'react-router-dom';

function GetToKnow() {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/about');
  };

  return (
    <div className='get-to-know'>
        <div className='get-placing'>
          <h1 className='get-title'>Get to know Beyond Schools</h1>
          <div className='paragraphy-text'>
            <p>BeyondSchools is an innovative online learning platform designed to empower students and educators alike in their quest for knowledge and personal development. Tailored specifically for Tanzanians, our platform offers a comprehensive suite of tools and resources that enhance both learning and teaching experiences.</p>
            <p className='space'>Join us in transforming education in Tanzania, where high-quality learning is just a click away</p>
          </div>
        </div>
        <div className='learn-more-button' onClick={handleLearnMore}>
            <span className="learn-more">Learn More</span>
        </div>
    </div>
  )
}

export default GetToKnow